//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features/index';
import { createSelector } from 'reselect';

import { ISite } from '@apis/galleries/galleriesApiModels';
import { getIsGalleriesEnabled } from '@galleries/selectors/getIsGalleriesEnabled';
import { ICuralateStore } from '@models/AppState';
import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

import { crl8 } from 'app/curalate.globals';

export enum GalleriesClientType {
  galleries = 'galleries',
  instashop = 'instashop',
  custom = 'custom',
  none = 'none',
}

export const getGalleriesClientTypeImpl = (
  galleriesEnabled: boolean,
  instashopEnabled: boolean,
  isFanreelEnabled: boolean,
  isCustomGalleriesEnabled: boolean,
  isLegacyApiClient: boolean,
  sites: ISite[],
) => {
  if (
    isCustomGalleriesEnabled &&
    (sites.some((site) => site.isCustom) || isLegacyApiClient)
  ) {
    return GalleriesClientType.custom;
  } else if (galleriesEnabled) {
    return GalleriesClientType.galleries;
  } else if (instashopEnabled) {
    return GalleriesClientType.instashop;
  } else {
    return GalleriesClientType.none;
  }
};

export const getGalleriesClientType = createSelector(
  getIsGalleriesEnabled,
  createHasFeatureSelector(FeatureNames.Instashop),
  createHasFeatureSelector(FeatureNames.Fanreel),
  createHasFeatureSelector(FeatureNames.GalleriesCustom),
  createHasFeatureSelector(FeatureNames.GalleriesCustomIsLegacyOrApiClient),
  (state: ICuralateStore) => state.galleries.data.sites,

  getGalleriesClientTypeImpl,
);

export default getGalleriesClientType;
